<template>
  <div class="service">
    <img
      width="80px"
      height="80px"
      :src="service.img ? service.img : imgUrl"
      alt="img"
    />
    <div class="service-content">
      <h1 class="service-title">
        {{ lang == "EN" ? service.title : service.enTitle }}
      </h1>
      <p class="service-detail">{{ content }}...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: Object,
    lang: String,
  },
  data() {
    return {
      imgUrl: require("../assets/img1.jpg"),
    };
  },
  computed: {
    content() {
      if (this.lang == "EN") {
        return this.service.content
          .replace(/<{1}[^>]*>{1}/g, " ")
          .substring(0, 40);
      } else {
        return this.service.enContent
          .replace(/<{1}[^>]*>{1}/g, " ")
          .substring(0, 40);
      }
    },
  },
};
</script>

<style>
.service-title {
  font-size: 18px;
  font-weight: bold;
}

.service-detail {
  color: #909399;
  margin: 0;
  margin-top: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-bottom: 10px;
}
.service {
  display: flex;
  /* margin-bottom: 10px;
  padding-bottom: 10px; */
  height: 120px;
  line-height: 120px;
  border-bottom: 1px solid #f2f6fc;
  align-items: center;
  cursor: pointer;
}

.service-content {
  margin-left: 20px;
}

.service-content h1 {
  line-height: 20px;
  margin: 0;
  font-weight: normal;
  font-size: 1.5em;
  text-align: left;
  margin-top: 10px;
}

.service-content p {
  line-height: normal;
  text-align: left;
  font-size: 1em;
}
</style>
